module.exports = __webpack_public_path__ + "img/Waehle_eine_Sammlung.bb4c5a93.jpg";